import React from 'react';
import { Redirect } from 'react-router-dom';
import { toast } from 'react-toastify';
import Joi from 'joi-browser';
import Form from './common/form';
import http from '../services/httpService';
import auth from '../services/authService';
import Spinner from './common/spinner';

class LoginForm extends Form {
  state = {
    data: { email: '', password: '' },
    errors: {},
    loading: false,
  };

  schema = {
    email: Joi.string().required().label('Email'),
    password: Joi.string().min(6).max(255).required().label('Password'),
  };

  doSubmit = async () => {
    //const tokenKey = 'token';
    // Call the server
    try {
      this.setState({ loading: true });

      const { data } = this.state;

      const result = await http.post('/auth/admin', {
        email: data.email,
        password: data.password,
      });

      const { data: response } = result;
      
      console.log(response.data)

      //console.log(response);

      if (!response.data.isAdmin) {
        toast('You are not authorized to view this dashboard');
        this.setState({ loading: false });
      } else {
        const { idToken: jwt } = response.data;
        //localStorage.setItem(tokenKey, jwt);

        this.setState({ loading: false });
        //const { state } = this.props.location;
        //window.location = state ? state.from.pathname : '/';
        this.props.history.push({
          pathname: '/twofa',
          jwt: jwt,
          email : data.email,
        });
      }
    } catch (ex) {
      if (ex.response && ex.response.status === 400) {
        this.setState({ loading: false });
        const errors = { ...this.state.errors };
        console.log(errors);
        toast('Invalid Email or Password');
      }
    }
  };

  render() {
    const { loading } = this.state;
    if (auth.getCurrentUser()) return <Redirect to="/" />;
    return (
      <div className="container" style={{ marginTop: 3 + '%' }}>
        <div className="row">
          <div
            className="col-md-6 offset-md-3"
            style={{ marginTop: 50 + 'px' }}
          >
            <div className="text-center">
              <img
                src={require('../assets/images/jeriod_logo.png')}
                alt=""
                height="50px"
              />
              <h4
                className="h4 mb-2 login-welcome-text"
                style={{ marginTop: 20 + 'px', fontWeight: 'bold' }}
              >
                Welcome Back!
              </h4>
              <p style={{ color: '#000524' }}>
                Please login to Jeroid Admin Dashboard
              </p>
            </div>
            <div
              className="card card-register mx-auto mt-2"
              style={{ border: 0, borderRadius: 0, marginBottom: 10 + '%' }}
            >
              <div
                className="card-header"
                style={{
                  backgroundColor: 'white',
                  borderBottom: 0,
                  marginTop: 2 + '%',
                  fontWeight: 'bold',
                }}
              >
                Access Credentials
              </div>
              <hr
                style={{
                  marginRight: 20 + 'px',
                  marginLeft: 20 + 'px',
                  marginTop: 0,
                  marginBottom: 0,
                }}
              />
              <div className="card-body">
                <form onSubmit={this.handleSubmit}>
                  <div className="form-row">
                    <div className="col-md-6">
                      {this.renderInput(
                        'email',
                        'Email Address',
                        'Email Address',
                        'autofocus',
                        'email'
                      )}
                    </div>
                    <div className="col-md-6">
                      {this.renderInput(
                        'password',
                        'Password',
                        'Password',
                        '',
                        'password'
                      )}
                    </div>
                  </div>

                  <div className="text-center">
                    <button
                      onClick={this.doSubmit}
                      disabled={!loading ? this.validate() : loading}
                      className="btn btn-invest btn-sm"
                    >
                      {loading && <Spinner message="Logging in..." />}
                      {loading && <span>Logging in...</span>}
                      {!loading && <span>Login</span>}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LoginForm;
